// @ts-nocheck
import { fabric } from 'fabric';
import { ANNOTATION_TYPE } from '../../../config';

let NoiseEvent;

(function () {
  NoiseEvent = function (canvasObject: any, event: any, offsetX: any, config: any) {
    this.type = ANNOTATION_TYPE.NOISE_EVENT;
    this.canvas = canvasObject;
    this.config = config;
    this.isVisible = true;
    this.xr = event.startSample;
    this.spp = (config.samplingRate * config.wndDuration) / config.width;
    this.x = (this.xr - offsetX) / this.spp;
    this.xr2 = event.endEventSample;
    this.x2 = (this.xr2 - offsetX) / this.spp;
  };

  NoiseEvent.prototype.draw = function () {
    this.rect = new fabric.Rect({
      left: this.x,
      top: 0,
      width: this.x2 - this.x,
      height: this.config.height,
      fill: 'rgba(255, 192, 0, 0.4)',
      selectable: false,
      hasBorders: false,
      hoverCursor: 'arrow',
    });
    this.rect.id = 'rect';
    this.canvas.add(this.rect);
  };

  NoiseEvent.prototype.render = function () {
    this.canvas.renderAll();
  };

  NoiseEvent.prototype.update = function () {
    // Can not modify this object
  };

  NoiseEvent.prototype.updateConfig = function (config: any, offsetX: any) {
    this.config = config;
    this.spp = (config.samplingRate * config.wndDuration) / config.width;

    this.x = (this.xr - offsetX) / this.spp;
    this.x2 = (this.xr2 - offsetX) / this.spp;

    const leftVal = this.x;
    const rightVal = this.x2;
    this.rect.set({
      left: this.x,
      width: this.x2 - this.x,
      height: this.config.height,
    });
    this.rect.setCoords();

    if (
      (leftVal < 0 && rightVal < 0) ||
      (leftVal > this.config.width && rightVal > this.config.width)
    ) {
      this.isVisibility(false);
    } else {
      this.isVisibility(true);
    }
  };

  NoiseEvent.prototype.scroll = function (offsetX: any) {
    this.x = (this.xr - offsetX) / this.spp;
    this.x2 = (this.xr2 - offsetX) / this.spp;

    const leftVal = this.x;
    const rightVal = this.x2;
    this.rect.set({ left: leftVal });
    this.rect.setCoords();

    if (
      (leftVal < 0 && rightVal < 0) ||
      (leftVal > this.config.width && rightVal > this.config.width)
    ) {
      this.isVisibility(false);
    } else {
      this.isVisibility(true);
    }
  };

  NoiseEvent.prototype.isSelected = function () {
    return false; // Can not select this annotation
  };

  NoiseEvent.prototype.select = function () {
    // Can not select this annotation
  };

  NoiseEvent.prototype.deselect = function () {
    // Can not deselect this annotation
  };

  NoiseEvent.prototype.isVisibility = function (isVisibility: any) {
    this.rect.visible = isVisibility;
    this.isVisible = isVisibility;
  };

  NoiseEvent.prototype.getJSONObject = function () {
    return {
      type: this.type,
      position: { xr: this.xr, xr2: this.xr2 },
    };
  };

  NoiseEvent.prototype.import = function () {
    // This object import by create instance
  };
})();

export { NoiseEvent };
export default { NoiseEvent };
